import LangEnum from '../../../lang/LangEnum';
import { ActionEnum } from '../actions/types/orderActions.types';

const useFinishOrderModalCopy = (action?: ActionEnum, customerCommercialName?: string) => {
  const trimmedCustomerName = customerCommercialName?.trim().toLowerCase();
  const hasCustomerName = !!trimmedCustomerName;

  const getBodyLang = () => {
    switch (action) {
      case ActionEnum.FINISH_TO_APPROVED:
        return hasCustomerName
          ? LangEnum.ORDER_FINISH_MODAL_BODY_TO_APPROVED_WITH_CUSTOMER
          : LangEnum.ORDER_FINISH_MODAL_BODY_TO_APPROVED;
      case ActionEnum.FINISH_TO_ON_APPROVAL:
        return hasCustomerName
          ? LangEnum.ORDER_FINISH_MODAL_BODY_TO_ON_APPROVAL_WITH_CUSTOMER
          : LangEnum.ORDER_FINISH_MODAL_BODY_TO_ON_APPROVAL;
      case ActionEnum.FINISH_TO_IN_REVISION:
        return hasCustomerName
          ? LangEnum.ORDER_FINISH_MODAL_BODY_TO_IN_REVISION_WITH_CUSTOMER
          : LangEnum.ORDER_FINISH_MODAL_BODY_TO_IN_REVISION;
      default:
        return undefined;
    }
  };

  return {
    titleLang: LangEnum.ORDER_FINISH_BUTTON_LABEL,
    bodyLang: getBodyLang(),
    trimmedCustomerName,
  };
};

export default useFinishOrderModalCopy;
